export const MobileHandlers = {
  computed: {
    isTablet () {
      return this.$viewportWidth < 992
    },
    isMobile () {
	    return this.$viewportWidth < 768
	  }
  }
}